/* Device catalog for the configurator.
   Sizes are in millimetres (w × h × d, as seen from the side we customise) and only drive the 3D preview,
   so close-enough values are fine. To add a model, copy a line and adjust it.

   phone.cam  — camera layout:  plateau3 | plateau1 | pill2 | square3 | diag2 | single | vert3 | ultra | ultraIsland | island3 | square4 | circle
   phone.front — screen cut-out: island (default on iPhone) | notch | hole (default elsewhere)
   iqos.kind  — charger | prime | one   (+ gen: 'i' for the 2024 "i" generation: ribbed door, touch-screen holder)
   earbuds.kind — pro | round | buds | clear (transparent lid)  (+ loop: true — lanyard loop)
   gamepad.kind — ps5 | ds4 | xbox | switch */

export const CATEGORIES = ['phone', 'iqos', 'earbuds', 'gamepad'];

export const CATALOG = {
  phone: [
    {
      id: 'apple', name: 'Apple', models: [
        { id: 'iphone-17-pro-max', name: 'iPhone 17 Pro Max', w: 78.0, h: 163.4, d: 8.75, r: 12.5, cam: 'plateau3' },
        { id: 'iphone-17-pro', name: 'iPhone 17 Pro', w: 71.9, h: 150.0, d: 8.75, r: 11.5, cam: 'plateau3' },
        { id: 'iphone-air', name: 'iPhone Air', w: 74.7, h: 156.2, d: 5.64, r: 12, cam: 'plateau1' },
        { id: 'iphone-17', name: 'iPhone 17', w: 71.5, h: 149.6, d: 7.95, r: 11.5, cam: 'pill2' },
        { id: 'iphone-16-pro-max', name: 'iPhone 16 Pro Max', w: 77.6, h: 163.0, d: 8.25, r: 12.5, cam: 'square3' },
        { id: 'iphone-16-pro', name: 'iPhone 16 Pro', w: 71.5, h: 149.6, d: 8.25, r: 11.5, cam: 'square3' },
        { id: 'iphone-16-plus', name: 'iPhone 16 Plus', w: 77.8, h: 160.9, d: 7.8, r: 12, cam: 'pill2' },
        { id: 'iphone-16', name: 'iPhone 16', w: 71.6, h: 147.6, d: 7.8, r: 11, cam: 'pill2' },
        { id: 'iphone-16e', name: 'iPhone 16e', w: 71.5, h: 146.7, d: 7.8, r: 11, cam: 'single', front: 'notch' },
        { id: 'iphone-15-pro-max', name: 'iPhone 15 Pro Max', w: 76.7, h: 159.9, d: 8.25, r: 12, cam: 'square3' },
        { id: 'iphone-15-pro', name: 'iPhone 15 Pro', w: 70.6, h: 146.6, d: 8.25, r: 11, cam: 'square3' },
        { id: 'iphone-15-plus', name: 'iPhone 15 Plus', w: 77.8, h: 160.9, d: 7.8, r: 12, cam: 'diag2' },
        { id: 'iphone-15', name: 'iPhone 15', w: 71.6, h: 147.6, d: 7.8, r: 11, cam: 'diag2' },
        { id: 'iphone-14-pro-max', name: 'iPhone 14 Pro Max', w: 77.6, h: 160.7, d: 7.85, r: 12, cam: 'square3' },
        { id: 'iphone-14-pro', name: 'iPhone 14 Pro', w: 71.5, h: 147.5, d: 7.85, r: 11, cam: 'square3' },
        { id: 'iphone-14', name: 'iPhone 14', w: 71.5, h: 146.7, d: 7.8, r: 10.5, cam: 'diag2', front: 'notch' },
        { id: 'iphone-13', name: 'iPhone 13', w: 71.5, h: 146.7, d: 7.65, r: 10.5, cam: 'diag2', front: 'notch' },
      ],
    },
    {
      id: 'samsung', name: 'Samsung', models: [
        { id: 'galaxy-s26-ultra', name: 'Galaxy S26 Ultra', w: 78.1, h: 163.6, d: 7.9, r: 9, cam: 'ultraIsland' },
        { id: 'galaxy-s26-plus', name: 'Galaxy S26+', w: 75.8, h: 158.4, d: 7.3, r: 11, cam: 'island3' },
        { id: 'galaxy-s26', name: 'Galaxy S26', w: 71.5, h: 149.4, d: 6.9, r: 10.5, cam: 'island3' },
        { id: 'galaxy-s25-ultra', name: 'Galaxy S25 Ultra', w: 77.6, h: 162.8, d: 8.2, r: 9, cam: 'ultra' },
        { id: 'galaxy-s25-plus', name: 'Galaxy S25+', w: 75.8, h: 158.4, d: 7.3, r: 11, cam: 'vert3' },
        { id: 'galaxy-s25', name: 'Galaxy S25', w: 70.5, h: 146.9, d: 7.2, r: 10.5, cam: 'vert3' },
        { id: 'galaxy-s24-ultra', name: 'Galaxy S24 Ultra', w: 79.0, h: 162.3, d: 8.6, r: 6, cam: 'ultra' },
        { id: 'galaxy-s24', name: 'Galaxy S24', w: 70.6, h: 147.0, d: 7.6, r: 10.5, cam: 'vert3' },
        { id: 'galaxy-a56', name: 'Galaxy A56', w: 77.5, h: 162.2, d: 7.4, r: 11, cam: 'island3' },
        { id: 'galaxy-a36', name: 'Galaxy A36', w: 78.2, h: 162.9, d: 7.4, r: 11, cam: 'island3' },
        { id: 'galaxy-a55', name: 'Galaxy A55', w: 77.4, h: 161.1, d: 8.2, r: 11, cam: 'vert3' },
        { id: 'galaxy-a35', name: 'Galaxy A35', w: 78.0, h: 161.7, d: 8.2, r: 11, cam: 'vert3' },
      ],
    },
    {
      id: 'xiaomi', name: 'Xiaomi / Redmi', models: [
        { id: 'xiaomi-15-ultra', name: 'Xiaomi 15 Ultra', w: 75.3, h: 161.3, d: 9.35, r: 10, cam: 'circle' },
        { id: 'xiaomi-15', name: 'Xiaomi 15', w: 67.5, h: 152.3, d: 8.1, r: 10, cam: 'square4' },
        { id: 'redmi-note-14-pro-plus', name: 'Redmi Note 14 Pro+', w: 74.7, h: 162.5, d: 8.75, r: 11, cam: 'square4' },
        { id: 'redmi-note-14-pro', name: 'Redmi Note 14 Pro', w: 74.4, h: 162.3, d: 8.2, r: 11, cam: 'square4' },
        { id: 'redmi-note-14', name: 'Redmi Note 14', w: 75.0, h: 163.3, d: 8.2, r: 11, cam: 'square4' },
      ],
    },
    { id: 'other', name: null, models: [] },
  ],

  iqos: [
    {
      id: 'iqos', name: 'IQOS', models: [
        { id: 'iluma-i-prime', name: 'ILUMA i PRIME', kind: 'prime', w: 44.7, h: 117.2, d: 22.2, gen: 'i' },
        { id: 'iluma-i', name: 'ILUMA i', kind: 'charger', w: 47.0, h: 121.5, d: 23.4, gen: 'i' },
        { id: 'iluma-i-one', name: 'ILUMA i ONE', kind: 'one', w: 30.6, h: 121.6, d: 21.0, gen: 'i' },
        { id: 'iluma-prime', name: 'ILUMA PRIME', kind: 'prime', w: 44.7, h: 117.2, d: 22.2 },
        { id: 'iluma', name: 'ILUMA', kind: 'charger', w: 47.0, h: 121.5, d: 23.4 },
        { id: 'iluma-one', name: 'ILUMA ONE', kind: 'one', w: 30.6, h: 121.6, d: 21.0 },
      ],
    },
    { id: 'other', name: null, models: [] },
  ],

  earbuds: [
    {
      id: 'apple', name: 'Apple', models: [
        { id: 'airpods-pro-3', name: 'AirPods Pro 3', kind: 'pro', w: 62.2, h: 47.2, d: 21.8 },
        { id: 'airpods-pro-2', name: 'AirPods Pro 2', kind: 'pro', w: 60.6, h: 45.2, d: 21.7, loop: true },
        { id: 'airpods-4', name: 'AirPods 4', kind: 'round', w: 50.1, h: 46.2, d: 21.2 },
        { id: 'airpods-3', name: 'AirPods 3', kind: 'round', w: 54.4, h: 46.4, d: 21.4 },
      ],
    },
    {
      id: 'samsung', name: 'Samsung', models: [
        { id: 'galaxy-buds4-pro', name: 'Galaxy Buds4 Pro', kind: 'clear', w: 58.9, h: 48.7, d: 24.4 },
        { id: 'galaxy-buds3-pro', name: 'Galaxy Buds3 Pro', kind: 'clear', w: 58.9, h: 48.7, d: 24.4 },
        { id: 'galaxy-buds3', name: 'Galaxy Buds3', kind: 'clear', w: 58.9, h: 48.7, d: 24.4 },
        { id: 'galaxy-buds-fe', name: 'Galaxy Buds FE', kind: 'buds', w: 50.0, h: 50.0, d: 27.8 },
        { id: 'galaxy-buds2-pro', name: 'Galaxy Buds2 Pro', kind: 'buds', w: 50.0, h: 50.2, d: 27.8 },
      ],
    },
    { id: 'other', name: null, models: [] },
  ],

  gamepad: [
    {
      id: 'sony', name: 'PlayStation', models: [
        { id: 'dualsense', name: 'DualSense (PS5)', kind: 'ps5' },
        { id: 'dualsense-edge', name: 'DualSense Edge', kind: 'ps5' },
        { id: 'dualshock-4', name: 'DualShock 4 (PS4)', kind: 'ds4' },
      ],
    },
    {
      id: 'microsoft', name: 'Xbox', models: [
        { id: 'xbox-wireless', name: 'Xbox Wireless Controller', kind: 'xbox' },
        { id: 'xbox-elite-2', name: 'Xbox Elite Series 2', kind: 'xbox' },
      ],
    },
    {
      id: 'nintendo', name: 'Nintendo', models: [
        { id: 'switch-2-pro', name: 'Switch 2 Pro Controller', kind: 'switch' },
        { id: 'switch-pro', name: 'Switch Pro Controller', kind: 'switch' },
      ],
    },
    { id: 'other', name: null, models: [] },
  ],
};

// Fallback geometry when the client picks "other brand / other model".
export const GENERIC = {
  phone: { w: 74, h: 158, d: 8, r: 11, cam: 'square3' },
  iqos: { kind: 'charger', w: 47.0, h: 121.5, d: 23.4 },
  earbuds: { kind: 'pro', w: 60, h: 46, d: 22 },
  gamepad: { kind: 'ps5' },
};

export function findModel(category, brandId, modelId) {
  const brand = (CATALOG[category] || []).find((b) => b.id === brandId);
  const model = brand && brand.models.find((m) => m.id === modelId);
  return { brand, model };
}
